/**
 * @vuepress
 * ---
 * title: Account
 * ---
 */

import Transformer from '@/transformers/transformer'
import { auroraUserFullName } from '@/transformers/utils'
/**
 * @class AccountTransformer
 * Account Info transformer
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 */

class AccountTransformer extends Transformer {
  /**
   * Transform fetched accont info
   *
   * @param account The fetched account
   *
   * @returns {Object} The transformed account
   */

  static fetch(account) {
    return {
      userId: account.id,
      username: account.username,
      fullName: auroraUserFullName(account),
      firstName: account.first_name,
      lastName: account.last_name,
      secondLastName: account.mothers_last_name,
      group: account.group
    }
  }
}

export default AccountTransformer
